import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/**
@return { Array }
*/
export const getAccountAlias = state => state.accountAlias

/**
@return { String }
*/
export const getAccountAliasSMSPhoneNumber = state => {
    return state.smsPhoneNumber
}

/**
@return { Object }
*/
export const getCustomer = state => state.customer

/**
@return { Array }
*/
export const getAccountsPlafond = state => state.plafond

/**
@return { Array }
*/
export const getAccountsTransactionLimit = state => state.transactionLimit
